import { captureException as sentryCaptureException } from '@sentry/react';
import { useEffect } from 'react';
import { useLocation, useRouteError } from 'react-router-dom';

import { ErrorIndicator } from '@components/ErrorIndicator';
import { Layout } from '@components/Layout';
import { useSyncPath } from '@features/Partner/useSyncPath';
import { SessionControls } from '@features/Remote/SessionControls';
import { useLoader } from '@hooks/useLoader';
import { LocalSessionAddressProvider } from '@providers/basket';
import { RequestState } from '@src/types/index';

const ErrorBoundary = () => {
  const error = useRouteError();
  const { setRequestState } = useLoader();
  const syncPath = useSyncPath();
  const { pathname } = useLocation();

  useEffect(() => {
    syncPath(pathname);
  }, [pathname, syncPath]);

  useEffect(() => {
    sentryCaptureException(error);
    setRequestState(RequestState.success);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <LocalSessionAddressProvider>
      <SessionControls>
        <Layout isErrorBoundary>
          <ErrorIndicator />
        </Layout>
      </SessionControls>
    </LocalSessionAddressProvider>
  );
};

export { ErrorBoundary };
